
  import Vue from "vue";
  export default Vue.extend({
    name: "QTDogRegistrationRequest",
    props: {
      registration: { type: Object },
    },
  });
  